import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormHelperText,
  Box,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  errorMsg: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.error.main,
    lineHeight: theme.typography.pxToRem(23),
    '& a': {
      color: theme.palette.error.main,
    },
  },
  baseError: {
    margin: 0,
    paddingLeft: theme.spacing(2),
  },
  itemError: {
    display: 'block',
  },
}));

const FormErrors = ({
  errorMsgs, showBaseErrors, errorField,
}) => {
  const classes = useStyles();

  if (!errorMsgs) return null;

  return (
    <>
      {
        showBaseErrors ? (
          <>
            {(
              (errorMsgs.errors?.base && errorMsgs.errors.base.length > 0)
                || errorMsgs.error_message) && (
                <Box mb={4}>
                  <Alert variant="filled" severity="error">
                    <ul className={classes.baseError}>
                      {errorMsgs.error_message && <li>{errorMsgs.error_message}</li>}
                      {errorMsgs.errors.base?.map((err) => <li key={err}>{err}</li>)}
                    </ul>
                  </Alert>
                </Box>
            )}
          </>
        )
          : (
            <>
              {
            errorField
              ? (
                <FormHelperText error>
                  {errorMsgs.errors?.[errorField]
                && (
                  Array.isArray(errorMsgs.errors[errorField]) && errorMsgs.errors[errorField].map((error) => (
                    <span className={classes.itemError} key={error}>
                      {error}
                    </span>
                  ))

                )}
                </FormHelperText>
              )
              : (
                <FormHelperText error>
                  {errorMsgs.errors && Array.isArray(Object.keys(errorMsgs.errors))
                && Object.keys(errorMsgs.errors).map((err) => (
                  <React.Fragment key={err}>
                    {
                      err !== 'base' && Array.isArray(errorMsgs.errors[err]) && errorMsgs.errors[err].map((error) => (
                        <span className={classes.itemError} key={error}>
                          {error}
                        </span>
                      ))
                    }
                  </React.Fragment>

                ))}
                </FormHelperText>
              )
          }
            </>
          )
    }
    </>
  );
};

export default FormErrors;
